import { useQuery } from "@tanstack/react-query";
import { recurringApi } from "../api/recurring";
import { queryClient } from "../../../shared/providers/QueryProvider";

interface UseOperationsProps {
  projectId: string | undefined;
  startDate?: string;
  endDate?: string;
}

interface UseOperationsReturn {
  operations: any[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
  removeCache: () => void;
}

export const useOperations = ({ projectId, startDate, endDate }: UseOperationsProps): UseOperationsReturn => {

  const { data, isLoading, isPending, isRefetching, isError, refetch } = useQuery({
    queryKey: ["recurring-list", projectId, startDate, endDate],
    queryFn: () => recurringApi.getRecurringTasks({ projectId, startDate, endDate }),
    enabled: !!projectId,
  });

  return {
    operations: data?.data?.rows ?? [],
    loading: isLoading || isPending || isRefetching,
    error: isError ? "Failed to load operations." : null,
    refetch,
    removeCache: () => { queryClient.removeQueries({ queryKey: ["recurring-list", projectId] }); }
  };

};